// extracted by mini-css-extract-plugin
export default {"user":"pofile_user__b19B4","userBlur":"pofile_userBlur__hqwUf","input":"pofile_input__Rrag6"};